import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle } from "lucide-react";
import { postDesabonnementInfolettre } from "@/lib/api";

export default function Desabonnement() {
  const [params] = useSearchParams();
  const [statut, setStatut] = useState("chargement");
  const demandeEnvoyee = useRef(false);
  const token = params.get("token") || "";

  useEffect(() => {
    if (!token) {
      setStatut("erreur");
      return;
    }
    if (demandeEnvoyee.current) return;
    demandeEnvoyee.current = true;
    postDesabonnementInfolettre(token)
      .then(() => setStatut("succes"))
      .catch(() => setStatut("erreur"));
  }, [token]);

  return (
    <section className="bg-background py-32" data-testid="desabonnement-page">
      <div className="mx-auto max-w-2xl px-6 text-center">
        {statut === "chargement" && (
          <p className="text-foreground/60" data-testid="desabonnement-loading">Confirmation de votre désabonnement…</p>
        )}
        {statut === "succes" && (
          <>
            <CheckCircle2 size={44} strokeWidth={1.5} className="mx-auto text-primary" />
            <h1 className="mt-6 font-serif text-4xl font-medium" data-testid="desabonnement-success-title">Désabonnement confirmé</h1>
            <p className="mt-4 text-base leading-relaxed text-foreground/65">
              Vous ne recevrez plus l'infolettre de la Fondation HORA. Vous pourrez vous réinscrire en tout temps depuis le site.
            </p>
          </>
        )}
        {statut === "erreur" && (
          <>
            <XCircle size={44} strokeWidth={1.5} className="mx-auto text-destructive" />
            <h1 className="mt-6 font-serif text-4xl font-medium" data-testid="desabonnement-error-title">Lien invalide</h1>
            <p className="mt-4 text-base leading-relaxed text-foreground/65">
              Ce lien de désabonnement est invalide ou a déjà été utilisé.
            </p>
          </>
        )}
        <Link to="/" className="mt-8 inline-block rounded-sm bg-primary px-7 py-3 text-sm font-semibold text-primary-foreground" data-testid="desabonnement-home-link">
          Retour à l'accueil
        </Link>
      </div>
    </section>
  );
}
